import { useEffect, useRef, useState } from 'react';
import styles from './EveningReflection.module.css';

interface EveningReflectionProps {
  word: string;
  initial?: string;
  onSave: (text: string) => void;
}

export function EveningReflection({ word, initial = '', onSave }: EveningReflectionProps) {
  const [open, setOpen] = useState(initial.length > 0);
  const [draft, setDraft] = useState(initial);
  const timer = useRef<number | null>(null);

  // Autosave with debounce
  useEffect(() => {
    if (timer.current !== null) clearTimeout(timer.current);
    timer.current = window.setTimeout(() => {
      onSave(draft);
    }, 600);
    return () => {
      if (timer.current !== null) clearTimeout(timer.current);
    };
  }, [draft, onSave]);

  if (!open) {
    return (
      <button
        type="button"
        className={styles.prompt}
        onClick={() => setOpen(true)}
      >
        reflect on today's word?
      </button>
    );
  }

  return (
    <section className={styles.box}>
      <label htmlFor="reflection-text" className={styles.label}>
        where did <em>{word}</em> show up today?
      </label>
      <textarea
        id="reflection-text"
        className={styles.textarea}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        placeholder="write what you noticed…"
        rows={4}
      />
      <p className={styles.hint}>
        saved automatically · stays in your browser only
      </p>
    </section>
  );
}
